import React, { Fragment, useState, createRef } from 'react'
import "./share.css";
import { faImage } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAvtar }  from "../utils"
import { FileSelection } from '../../../../containers/Files';
import { showLoader } from '../../../../store/actions/loader';
import { AlertJsMessage } from '../../../../helpers.js';
import COLORS from '../../../../styles/colors';
import { VALIDATION_MESSAGES } from '../../../../static-content';
import Button from '@material-ui/core/Button';
import Compressor from 'compressorjs';
import AWS_S3 from 'aws-sdk/clients/s3';
import Badge from '@material-ui/core/Badge';
import { withStyles, styled } from '@material-ui/core/styles';
import EmojiButton from './../../../EmojiButton';
import { 
	S3_BUCKET_NAME, 
	IMAGE_SIZE_LIMIT_BYTES, 
	VIDEO_SIZE_LIMIT_BYTES,
	MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES, 
	TOPIC_VIDEO_SIZE_LIMIT_BYTES 
  } from '../../../../constants';

const acceptTypes = {
  mixed: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'video/mov'],
  video: ['video/mp4', 'video/quicktime', 'video/mov'],
  image: ['image/gif', 'image/jpeg', 'image/jpg', 'image/png'],
  audio: ['.mp3', '.m4a']
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
      right: 0,
      top: 0,
      backgroundColor: 'rgb(234, 94, 1)',
      fontSize: '10px'
  },
}));


class PostForm extends React.Component {
  
  constructor(props) {
		super(props);
		this.state = {
			submitAction: 'create',
			editItem: null,
			fileLoaded: false,
			videoModal: false,
			formData: {
				description: ''
			},
			previewImageSrc: '',
			previewVideoSrc: '',
		};
	}

	componentDidMount() {
		if(this.props.editId) {
			this.props.fetch(this.props.editId, 'post').then((res) => {
				this.setState({
					...this.state,
					submitAction: 'edit',
					editItem: res,
					formData: {
						description: res.description
					},
					dataLoaded: true,
				})
				if (this.props.isMobile && res.url && res.url!=='') {
					if(res.isImage) {
						this.setState({
							previewImageSrc: res.url,
							fileLoaded: true
						})
					} else {
						this.setState({
							previewVideoSrc: res.url,
							fileLoaded: true
						})
					}
				}
			});
		}
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value
				
			}
		});
	};

	handleFileChange({ target }, fileType) {
		const file = target.files[0];
		if (file) {
		  if (acceptTypes.image.includes(file.type) && (fileType === 'image' || fileType === 'mixed')) {
			if (file.size > IMAGE_SIZE_LIMIT_BYTES) {
			  AlertJsMessage(VALIDATION_MESSAGES.IMAGE_LIMIT_EXCEEDS(file.size));
			  target.value = '';
			  this.setState({
          previewImageSrc: '',
          previewVideoSrc: '',
          fileLoaded: false
			  })
			} else {
			 	const _that = this;
				new Compressor(file, {
				  quality: 0.2,
				  success(result) {
					var reader = new FileReader();
					reader.readAsDataURL(result);
					reader.onload = function () {
					  _that.setState({
              type: 'upload',
              uploadInput: target,
              previewImageSrc: reader.result,
              fileLoaded: true,
              openModal: false,
              isSubmitNewFile: true
					  })
					};
				}
			 })
			}
		  }
		  if (file.type === 'video/mp4' || file.type === 'video/quicktime' || file.type === 'video/mov') {
        const videoSize = TOPIC_VIDEO_SIZE_LIMIT_BYTES;
        if (file.size > videoSize) {
          AlertJsMessage(VALIDATION_MESSAGES.TOPIC_VIDEO_LIMIT_EXCEEDS(file.size));
          target.value = '';
          this.setState({
          previewImageSrc: '',
          previewVideoSrc: '',
          fileLoaded: false
          })
          return;
        } else {
          this.setState({
          type: 'upload',
          uploadInput: target,
          previewVideoSrc: window.URL.createObjectURL(file),
          previewImageSrc: '',
          fileLoaded: true,
          openModal: false,
          isSubmitNewFile: true
          })
        }
		  }
		} else {
			this.setState({
				previewImageSrc: '',
				previewVideoSrc: '',
				fileLoaded: false,
				isSubmitNewFile: false
			})
		    AlertJsMessage("No file selected.");
		}
	}

	submitNewFile() {
		this.setState({ isUploading: true });
		const { showLoader, hideLoader } = this.props;
		showLoader();
		const s3 = new AWS_S3({
			apiVersion: '2006-03-01',
			params: { Bucket: S3_BUCKET_NAME },
		});
		let file;
		file = this.state.uploadInput.files && this.state.uploadInput.files[0];
		const fileType = file && file.name.split('.').pop();
		let s3UploadObj = {
			Key: `COMMUNITY_ASSETS-${Date.now()}.${fileType}`,
			Body: file,
			ACL: 'public-read',
		};
		return new Promise((resolve, rej) => {
			if (file) {
				let isTranscoding;
				if (file.size > MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES || file.type === 'video/quicktime' || file.type === 'video/mov') {
					isTranscoding = true;
				}
				s3.upload(s3UploadObj, (err, ec2Data) => {
					if (err) {
						AlertJsMessage(
							'There was an error uploading your photo: ',
							err.message
						);
						hideLoader();
						rej('');
						return;
					}
					let file = {}
					if (acceptTypes.image.includes(fileType)) {
					  file.imageDimension = this.state.dimensions;
					}
					file.fileType = fileType;
					file.url = `https://${process.env.REACT_APP_ASSET_URL}/${ec2Data.Key}`;
					file.isTranscoding = isTranscoding;
					file.isUpload = true;
					resolve(file);
				});
			} else {
				hideLoader();
				rej('No File');
			}
		});
	}

	validateForm() {
		const { formData } = this.state;
		const { history, isMedia, isFormFields } = this.props;
    const required = [
    'description'
    ];
    for (var i = 0; i < required.length; i++) {
      if (!formData[required[i]]) {
        AlertJsMessage(VALIDATION_MESSAGES['TOPIC'][required[i]]);
        return;
      }
    }
    if (this.state.isSubmitNewFile) {
      this.setState({ isValidating: true }, () => {
        this.submitNewFile().then(file => {
            this.submitValidatedForm(formData, file);
        })
      })
    } else {
      this.submitValidatedForm(formData,  null);
    }
  
	}

	submitValidatedForm(formData, file) {
		const { history, editId, topicId } = this.props;
		const { editItem } = this.state;
		//const { dimensions } = this.fileSelect.state;
		if (file !== null) {
			formData.fileId = file._id;
			formData.url = file.url;
			formData.isAssetChange = true;
			formData.isUpload = file.isUpload;
			if (editItem !== null && (editItem.url === file.url)) {
				formData.isAssetChange = false
			}
			if (file.url.includes('mp4') 
			  || file.url.includes('quicktime') 
			  || file.url.includes('mov')) {
			  formData.isImage = false;
			  formData.isTranscodingJob = file.isTranscoding;
			} else {
			  // formData.imageDimensions = dimensions;
			  formData.isImage = true;
			}		  
		}
    formData.topicId = topicId;
		if (this.state.submitAction === 'create') {
		  this.props.create('post', formData).then((res) => {
			const _id = res.data.id;
			window.location.reload();
		  });
		}
		if (this.state.submitAction === 'edit') {
		  this.props.edit('post', { ...formData, id: editId }).then((res) => {
			window.location.reload();
		  });
		}
  }

  passEmoji = (emoji) => {
	const cursor = this.inputRef.selectionStart;
	const description = this.state.formData.description;
	const text = description.slice(0, cursor) + emoji + description.slice(cursor);
	this.setState({
		...this.state,
		formData: {
			...this.state.formData,
			description: text
		}
	})
  }

  render() {
    const { formData, editItem, previewVideoSrc, previewImageSrc, fileLoaded, isSubmitNewFile } = this.state;
	const { isMedia, isFormFields, isMobile, isMixedAsset, classes, user } = this.props;
    return (
      <div className={this.props.editId ? '' : isMobile ? 'mobile-share' : 'share'}>
        <div className="shareWrapper">
          <div className="shareTop">
            { user && 
              getAvtar(user)
            }
            <input
              placeholder="What's in your mind?"
              value={formData.description}
              onChange={this.handleChange('description')}
              className="shareInput"
			  ref={(ref) => { this.inputRef = ref  }}
            />
          </div>
          <hr className="shareHr"/>
          <div className="shareBottom">
              <div className="shareOptions">
              <input
										   type="file"
										   onChange={e => this.handleFileChange(e, 'mixed')}
										   accept={acceptTypes.toString()}
										   style={{ display: 'none' }}
                       ref={(ref) => { this.uploadInputRef = ref  }}
									   />
                  <div className="shareOption" onClick={() => {
                        this.uploadInputRef && this.uploadInputRef.click()
                      }}>
                        <StyledBadge
                            badgeContent={ isSubmitNewFile ? 1 : 0}
                            color="secondary"
                        >
                             <FontAwesomeIcon icon={faImage} size={"2x" } 
								               style={{ color: COLORS.orange }}  >
                            </FontAwesomeIcon>
                        </StyledBadge>
                 
                      <span className="shareOptionText">Photo or Video</span>
                      
                  </div>

				  <div className="shareOption" >
				  	  <EmojiButton passEmoji = {this.passEmoji}></EmojiButton>
                      <span className="shareOptionText">Feelings</span>
                      
                  </div>
                
              </div>
              <button className="shareButton" onClick={() => { this.validateForm()
									}}>Share</button>
          </div>
        </div>
      </div>
    );
  }
}

export default  PostForm;


// WEBPACK FOOTER //
// ./src/components/social/shared/share/PostForm.jsx